import { useState } from "react";
import { Box } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

function DashboardLayout({ children }) {
  // Mobile drawer open/close — shared between the hamburger in Header and the
  // off-canvas Sidebar drawer. Ignored on desktop (md+) where the rail is fixed.
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        // Flat light canvas (spec) — the ambient gradient backdrop is gone.
        background: "#F4F6FB",
        minHeight: "100vh",
      }}
    >
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header onMenuClick={() => setMobileOpen(true)} />

        <Box sx={{ p: { xs: 1.5, md: 3 }, flex: 1, minWidth: 0 }}>
          {/* Centre + cap content width so pages don't stretch edge-to-edge on
              ultrawide screens. Tables keep their own overflow-x scrollers. */}
          <Box sx={{ maxWidth: 1600, mx: "auto", width: "100%" }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DashboardLayout;
